var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"showInventory"},[(_vm.isSetInventory)?_c('span',[_vm._v(_vm._s(_vm.showInventorys))]):_vm._e(),_vm._v(" "),(!_vm.isSetInventory)?_c('span',[_vm._v(_vm._s(_vm._f("formatFilter")(_vm.showInventorys,_vm.type, _vm.format, _vm.symbol)))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }